import { Component } from '@angular/core';
import { TabComponent } from '../tab/tab.component';

@Component({
  selector: 'app-tabs',
  template: '<ng-content></ng-content>',
})
export class TabsComponent {
  tabs: TabComponent[] = [];

  addTab(tab: TabComponent) {
    this.tabs.push(tab);
  }

  selectTab(tab: TabComponent) {
    this.deactivateAllTabs();

    tab.active = true;
  }

  deactivateAllTabs() {
    this.tabs.forEach((tab: TabComponent) => {
      tab.active = false;
    });
  }

  getTabByID(tabIdentifier: number | string) {
    return this.tabs.findIndex((tab) => tab.identifier === tabIdentifier);
  }

  toggleTabByID(tabIdentifier: number | string) {
    this.deactivateAllTabs();

    const tabIndex = this.getTabByID(tabIdentifier);

    this.tabs[tabIndex].active = !this.tabs[tabIndex].active;
  }
}
